import PropTypes from 'prop-types'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import Icon from 'components/Icon'
import { Text } from 'styles/components/typography'

import {
  TextWrapper,
  Num,
  NumWrapper,
  IconWrapper,
  BoxBaseStyled,
} from './styles'

const WCoveringMobile = ({ data, viewport }) => {
  const { tablet, breakpoint } = viewport
  const [ref, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  })

  return (
    <BoxBaseStyled
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      ref={ref}
    >
      {breakpoint !== '' && (
        <NumWrapper isVisible={tablet && inView}>
          <Num dangerouslySetInnerHTML={{ __html: data.num }} />

          <IconWrapper>
            <Icon color="white" id="close_large" strokeWidth="15" />
          </IconWrapper>
        </NumWrapper>
      )}

      <TextWrapper isVisible={(tablet && inView) || viewport.breakpoint === ''}>
        <Text dangerouslySetInnerHTML={{ __html: data.text }} />
      </TextWrapper>
    </BoxBaseStyled>
  )
}

WCoveringMobile.propTypes = {
  data: PropTypes.object.isRequired,
  viewport: PropTypes.object.isRequired,
}

export default WCoveringMobile
